import React from "react";
import Register from "../components/Register";

const Registeration = () => {
  return (
    <>
      <Register />
    </>
  );
};

export default Registeration;
